import { Fragment, useMemo } from 'react'
import { Circle } from 'react-konva'
import { TableShape } from '../../types/floorPlan.model'
import {
  primaryColors,
  transparentColors
} from '@/assets/styles/helpers/colors.styles'
import {
  getSeatPositions,
  getSeatScale,
  SEAT_OUTER_RADIUS,
  SEAT_RADIUS
} from '../../utils/seatLayout'

// A solid dark-orange dot with a translucent-orange halo ring behind it, so the
// ring shows as an annulus (mirrors the SideBarDot halo treatment).
const SEAT_FILL = primaryColors.orange
const SEAT_HALO_FILL = transparentColors.orangeShade5

interface SeatRingProps {
  shape: TableShape
  seatCount: number
  width: number
  height: number
}

function SeatRing(props: SeatRingProps) {
  const { shape, seatCount, width, height } = props

  const seats = useMemo(
    () => getSeatPositions(shape, seatCount, width, height),
    [shape, seatCount, width, height]
  )

  // Scale seats (and their halos) down so neighbouring dots never overlap when
  // the table, and therefore the seat spacing, shrinks.
  const scale = useMemo(() => getSeatScale(seats), [seats])

  const innerRadius = SEAT_RADIUS * scale
  const outerRadius = SEAT_OUTER_RADIUS * scale

  return (
    <>
      {seats.map((seat, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <Circle
            x={seat.x}
            y={seat.y}
            radius={outerRadius}
            fill={SEAT_HALO_FILL}
            listening={false}
          />
          <Circle
            x={seat.x}
            y={seat.y}
            radius={innerRadius}
            fill={SEAT_FILL}
            listening={false}
          />
        </Fragment>
      ))}
    </>
  )
}

export default SeatRing
